import { LazyAction, LazyModule } from 'owa-bundling';

// Mutators
import './mutators/initializeSIGSDataMutator';

// Lazy
const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "SmartPillFeatures" */ './lazyIndex')
);

export let lazyLogToSIGSOnMessageSent = new LazyAction(lazyModule, m => m.logToSIGSOnMessageSent);

export { default as SmartReplyComposeSIGSData } from './store/schema/SmartReplyComposeSIGSData';

export {
    FeatureNames,
    FlightNames,
    GetItemManagerFeatureIds,
    SmartPillsAggregatedByFeature,
    SmartPillsFeatureArrangement,
} from './utils/constants';
